module.exports = __webpack_public_path__ + "static/media/trending.71d32fce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/trending.svg
// module id = 670
// module chunks = 0